import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from "./auth.service";
import { Debug } from "../_class/debug";
import { Log } from '../_class/log';

@Injectable({
  providedIn: 'root'
})
export class DebugsService {

  resource = `${environment.endpoint}/debug`
  constructor(private http: HttpClient, private auth: AuthService) { }

  getDebug(pk: number, params?: HttpParams | { [param: string]: string | string[]; }) {
    const headers = { 'Authorization': `${this.auth.session.type} ${this.auth.session.access_token}` }
    return this.http.get<Debug>(`${this.resource}/${pk}`, { headers, params })
  }

  getDebugs(params?: HttpParams | { [param: string]: string | string[]; }) {
    const headers = { 'Authorization': `${this.auth.session.type} ${this.auth.session.access_token}` }
    return this.http.get<Debug[]>(this.resource, { headers, params, observe: 'response' })
  }

  getLogs(pk: number, params?: HttpParams | { [param: string]: string | string[]; }) {
    const headers = { 'Authorization': `${this.auth.session.type} ${this.auth.session.access_token}` }
    return this.http.get<Log[]>(`${this.resource}/${pk}/logs`, { headers, params, observe: 'response' })
  }

  getFilters() {
    const headers = { 'Authorization': `${this.auth.session.type} ${this.auth.session.access_token}` }
    return this.http.get<{ app_name: string[], app_version: string[], app_platform: string[], app_company: string[], unity_version: string[] }>(`${this.resource}/filters`, { headers })
  }
}
